module.exports = __webpack_public_path__ + "img/ic_20_report_check.68ae74d0.svg";